import { Box, Tooltip } from '@mui/material'
import { IImpactBase, IUnSdg } from 'src/types'
import { getUniqueUnSdgsFromImpacts, getSdgNumberFromName } from 'src/utils/impact.util'
import { useStyles } from '../hover-icon/styles'

type Props = {
  sdgs?: IUnSdg[]
  impacts?: IImpactBase[]
}

export const UnSdgs = ({ sdgs, impacts }: Props) => {
  const classes = useStyles()

  const uniques = sdgs?.length ? sdgs : getUniqueUnSdgsFromImpacts(impacts || [])
  const ordered = [...uniques].sort(
    (a, b) => getSdgNumberFromName(a.name) - getSdgNumberFromName(b.name),
  )

  if (!ordered.length) return null

  return (
    <Box
      id="index__components-unsdgs__box__l22"
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '20px',
        flexWrap: 'wrap',
        px: '20px',
      }}
    >
      {ordered.map((sdg) => (
        <Tooltip
          id="index__components-unsdgs__tooltip__l33"
          title={sdg.name}
          PopperProps={{ className: classes.popper }}
        >
          <Box
            id="index__components-unsdgs__box__l34"
            key={sdg.id}
            sx={{
              display: 'block',
              lineHeight: 0,
              borderRadius: '6px',
              overflow: 'hidden',
              boxShadow: 1,
            }}
            aria-label={sdg.name}
          >
            <img
              id="index__components-unsdgs__img__l45"
              src={sdg.image_medium || sdg.image_small || sdg.image}
              alt={sdg.name}
              style={{ width: '50px', height: '50px', display: 'block' }}
              loading="lazy"
            />
          </Box>
        </Tooltip>
      ))}
    </Box>
  )
}
